module.exports = "<app-area-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() area=$ctrl.area switch-tab-prefix=app.area.update> </app-area-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/area/update/partial.html
// module id = 407
// module chunks = 0